import React from 'react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  HStack,
  Icon,
  NewButton,
  Text,
} from '@eluve/components';

export interface TemplateEditingPageHeaderButtonsProps {
  saveDraftDisabled?: boolean;
  submitDisabled?: boolean;
  handleSaveDraft: () => void;
  handleSubmit: () => void;
  handleDeleteDraft: () => void;
}

export const TemplateEditingPageHeaderButtons: React.FC<
  TemplateEditingPageHeaderButtonsProps
> = ({
  handleSaveDraft,
  handleSubmit,
  handleDeleteDraft,
  saveDraftDisabled = false,
  submitDisabled = false,
}) => {
  return (
    <HStack justify="end">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <NewButton type="ghost" icon={{ name: 'MoreHorizontal' }} />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem onClick={handleDeleteDraft}>
            <HStack>
              <Icon
                name="Trash"
                className="text-text-negative-subtle"
                size="sm"
              />
              <Text className="text-text-negative-subtle">Delete Draft</Text>
            </HStack>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <NewButton
        disabled={saveDraftDisabled}
        type="outline"
        text="Save Draft"
        onClick={handleSaveDraft}
      />
      <NewButton
        disabled={submitDisabled}
        onClick={handleSubmit}
        text="Submit Template"
        icon={{ name: 'Upload' }}
      />
    </HStack>
  );
};
